import { USER_ROLES } from "../lib/supabase";

/**
 * Filter navigation items based on user role using Set.has() for O(1) lookups
 */
export const filterNavByRole = (navItems, userRole) => {
  if (!userRole) return [];
  return navItems.filter((item) => item.visibleTo.has(userRole));
};

/**
 * Check if a user can access a specific page based on role (used by route guards)
 */
export const canAccessPageByRole = (userRole, pathname, pageAccess) => {
  if (!userRole || !pathname) return false;
  if (userRole === USER_ROLES.ADMIN) return true;

  const isRestricted = (pathSet) =>
    pathSet.has(pathname) ||
    [...pathSet].some((p) => pathname.startsWith(p + "/"));

  if (isRestricted(pageAccess.adminOnly)) {
    // Allow cause owners to access individual campaign request detail pages
    if (userRole === USER_ROLES.CAUSE && pathname.match(/^\/dashboard\/campaign-status\/[^/]+$/)) {
      return true;
    }
    return false;
  }

  if (isRestricted(pageAccess.causeOnly)) {
    return userRole === USER_ROLES.CAUSE;
  }

  if (userRole === USER_ROLES.GENERAL) {
    return !isRestricted(pageAccess.generalRestricted);
  }

  if (userRole === USER_ROLES.BRAND || userRole === USER_ROLES.CAUSE) {
    // A role-holder may always reach their OWN verification/onboarding form
    // (to complete a profile), even though it's verifiedRestricted for others.
    const ownForm =
      userRole === USER_ROLES.CAUSE ? "/dashboard/cause" : "/dashboard/brands";
    if (pathname === ownForm || pathname.startsWith(ownForm + "/")) return true;
    return !isRestricted(pageAccess.verifiedRestricted);
  }

  return true;
};
